import participantActions from "./participantActions";
import partyActions from "../VotifyParty/partyActions";
import moment from "moment";

const initialState = {
  /** @type {Object<string, number>} */
  votes: {}, // <trackUri: votes (int)>
  sortedVotes: [],
  /** @type {Object<string, string>} */
  participantVotes: {}, // <trackUri: userTrackId>
  isLoadingVote: false,
  isLoadingVotes: true,
  joinedPartyId: null,
  participantId: moment().unix(),
};

export const STATE_KEY = "participant";

const participantReducer = (state = initialState, action) => {
  switch (action.type) {
    case participantActions.END_VOTE_REQUEST:
      return {
        ...state,
        isLoadingVote: false,
      };
    case participantActions.START_VOTE_REQUEST:
      return {
        ...state,
        isLoadingVote: true,
      };
    case participantActions.HANDLE_VOTE:
      return {
        ...state,
        votes: {
          ...state.votes,
          [action.payload.trackUri]: state[action.payload.trackUri]
            ? state[action.payload.trackUri].votes + 1
            : 1,
        },
      };
    case participantActions.HANDLE_BAD_VOTE:
      return {
        ...state,
        participantVotes: {
          ...state.participantVotes,
          [action.payload.trackUri]: state.participantId,
        },
      };
    case participantActions.HANDLE_SEND_VOTE:
      return {
        ...state,
        participantVotes: {
          ...state.participantVotes,
          [action.payload.trackUri]: state.participantId,
        },
      };
    case participantActions.HANDLE_SUCCESS_VOTE:
      return {
        ...state,
        participantVotes: {
          ...state.participantVotes,
          [action.payload.trackUri]: action.payload.userTrackId,
        },
        votes: {
          ...state.votes,
          [action.payload.trackUri]: state[action.payload.trackUri]
            ? state[action.payload.trackUri].votes + 1
            : 1,
        },
      };
    case participantActions.LOAD_VOTES:
      const newParticipantVotes = {};
      const newVotes = {};
      for (const { trackId, votes } of action.payload) {
        newVotes[trackId] = votes;
        if (state.participantVotes[trackId]) {
          // Erasing participant votes for tracks that have been played
          newParticipantVotes[trackId] = state.participantId;
        }
      }
      return {
        ...state,
        sortedVotes: action.payload,
        isLoadingVotes: false,
        votes: newVotes,
        participantVotes: newParticipantVotes,
      };

    // NOT ABOUT VOTES:
    case partyActions.JOIN_PARTY:
      // Reset all votes by this participant when joining a new party
      if (action.payload.id === state.joinedPartyId) {
        return {
          ...state,
          joinedPartyId: action.payload.id,
        };
      } else {
        return {
          ...state,
          joinedPartyId: action.payload.id,
          participantVotes: {},
        };
      }
    case partyActions.LEAVE_PARTY:
      return {
        ...state,
        joinedPartyId: null,
      };
    default:
      return state;
  }
};

export default participantReducer;
